import { lazy } from "react"
import { LinkTo } from "shared/constants/linkTo"

const MagistracyApplicationPage = lazy(() => import("shared/pages/magistracy/MagistracyApplicationPage"))

const magistracyRoutes = [
  { path: LinkTo.magistracyApply, exact: true, component: MagistracyApplicationPage },
]

export default magistracyRoutes

import { lazy } from "react"
import { LinkTo } from "shared/constants/linkTo"

const MagistracyApplicationPage = lazy(() => import("shared/pages/magistracy/MagistracyApplicationPage"))

const magistracyRoutes = [
  { path: LinkTo.magistracyApply, exact: true, component: MagistracyApplicationPage },
]

export default magistracyRoutes

